<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Step</h1>
                <v-btn to="/step/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Step
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="5"
                align="center"
                justify="center"
            >
                <StepEditForm />
            </v-col>
            <v-col
                cols="12"
                md="3"
            >
                <StepStructure />
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Step: {{ name }}
                </v-card-title>
                <v-card-text>
                    <p>Deleting this step is permanent and cannot be undone.</p>
                    <p>Click "DELETE STEP" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Step
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import StepEditForm from './StepEditForm';
import StepStructure from './StepStructure';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, StepStructure, StepEditForm },


    computed: {
        ...mapState('stepEditor', ['deleteModal', 'name']),
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'stepEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'stepEditor/getData',
            saveData: 'stepEditor/saveData',
            destroyData: 'stepEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
